export const SunniesCarIcon = (): JSX.Element => (
  <svg width="152" height="148" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#a)">
      <ellipse cx="79" cy="41.727" rx="39" ry="31.5" fill="#FDDA05" />
      <path
        d="M62.474 5.63a.99.99 0 0 1 .616-1.268 1.01 1.01 0 0 1 1.273.628l-1.889.64Zm.945-.32.944-.32v-.002l-.001-.003-.001-.002.002.004.015.04a3.939 3.939 0 0 0 .485.818c.376.485.955 1.003 1.822 1.232l-.493 1.933c-1.412-.373-2.342-1.222-2.907-1.953a5.971 5.971 0 0 1-.753-1.28 3.222 3.222 0 0 1-.05-.129l-.005-.01-.001-.005-.001-.002V5.63l.944-.32Zm3.266 1.767c.745.197 1.297-.016 2.11-.453.77-.414 1.864-1.107 3.307-1.105l.017 2c-.83-.002-1.434.369-2.362.868-.885.476-2.032 1.027-3.565.623l.493-1.933Zm5.417-1.558c1.445.003 2.724.66 3.63 1.54.893.868 1.531 2.058 1.54 3.253l-2.001-.007c-.004-.517-.309-1.22-.925-1.818-.602-.585-1.398-.967-2.227-.968l-.017-2Zm5.17 4.793c.007 1.116-.35 1.766-.627 2.273-.234.428-.388.712-.383 1.308l-2-.007c-.008-1.116.348-1.766.625-2.273.234-.428.388-.712.384-1.308l2 .007ZM64.362.81a.998.998 0 1 1 1.811-.841l-1.81.84Zm.906-.42.905-.422v-.001.002a2.548 2.548 0 0 0 .052.103 7.623 7.623 0 0 0 .923 1.361c.663.776 1.498 1.396 2.449 1.442l-.09 1.998c-1.77-.085-3.076-1.207-3.875-2.142A9.63 9.63 0 0 1 64.366.817l-.002-.004-.001-.002.905-.422Zm4.329 2.485c.425.02.796-.102 1.216-.35.486-.287.846-.607 1.479-1.055.573-.406 1.27-.83 2.147-1.036.892-.21 1.894-.18 3.063.195l-.604 1.905c-.865-.278-1.496-.27-1.994-.153-.512.121-.963.377-1.454.724-.43.305-1.05.81-1.617 1.145-.633.374-1.39.668-2.325.623l.089-1.998ZM77.502.629c2.621.841 3.514 3.35 3.779 5.543.27 2.237-.047 4.578-.209 5.745l-1.98-.283c.163-1.178.44-3.281.204-5.229-.24-1.99-.951-3.407-2.398-3.87l.604-1.906Zm3.57 11.288c-.193 1.393-.68 2.138-1.096 2.774-.364.557-.657 1.004-.79 1.956l-1.98-.283c.194-1.393.68-2.138 1.097-2.774.364-.557.657-1.004.79-1.956l1.98.283Z"
        fill="#FDDA05"
      />
      <g filter="url(#b)">
        <ellipse
          rx="4.454"
          ry="3.11"
          transform="rotate(3.206 -710.813 1113.603) skewX(-.149)"
          fill="#FB9378"
          fillOpacity=".38"
        />
      </g>
      <g filter="url(#c)">
        <ellipse
          rx="4.253"
          ry="3.359"
          transform="matrix(.97038 -.24157 .38861 .9214 95.215 40.212)"
          fill="#FB9378"
          fillOpacity=".38"
        />
      </g>
      <path
        d="M80.53 44.354s-.521 1.143-2.306 1.604c-1.785.462-3.336-1.407-3.336-1.407"
        stroke="#CFB202"
        strokeLinecap="round"
      />
      <path
        d="M61.614 36.506a1.492 1.492 0 0 1 1.476-1.508l11.736-.121a1.867 1.867 0 0 1 1.886 1.847 5.595 5.595 0 0 1-5.537 5.655l-3.526.037a5.975 5.975 0 0 1-6.035-5.91ZM78.975 36.7a1.865 1.865 0 0 1 1.846-1.885l11.736-.122c.824-.008 1.5.653 1.508 1.478a5.968 5.968 0 0 1-5.906 6.032l-3.526.037a5.601 5.601 0 0 1-5.658-5.54Z"
        fill="#212121"
      />
      <path d="M75.206 37.042c2.046-.88 3.215-.953 5.282-.055" stroke="#000" />
    </g>
    <path
      d="M27.227 135.517c-.846 7.146-2.155 12.414-7.87 11.835-5.716-.58-5.151-5.923-4.304-13.069.295-2.496.874-6.803 6.59-6.223 5.715.579 5.96 4.282 5.584 7.457ZM134.271 134.29c.767 7.154.663 12.558-5.059 13.083-5.721.525-6.362-4.811-7.129-11.964-.268-2.5-.663-6.823 5.059-7.348 5.721-.525 6.788 3.05 7.129 6.229Z"
      fill="#AFDAF7"
    />
    <g filter="url(#d)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m128.836 83.828.05-.256C133.076 61.48 108.032 51 79.284 51c-27.949 0-54.226 10.708-50.32 30.823C15.012 88.799 6.291 100.48 5 118.694c0 17.52 31.644 17.844 72.567 17.844 40.924 0 68.894-.324 68.894-17.844 2.634-15.914-4.565-27.401-17.625-34.866Z"
        fill="#DFF0FC"
      />
    </g>
    <path
      d="M117.624 82c-2.4 11.435-16.349-1.648-38.886-1.648-22.536 0-39.126 10.475-39.126 1.649-4.56-15.046 16.59-23.07 39.126-23.07 22.537 0 42.171 7.422 38.886 23.07Z"
      fill="#AFDAF7"
    />
    <ellipse cx="29.19" cy="109.914" rx="8.573" ry="5.098" fill="#AFDAF7" />
    <ellipse cx="121.047" cy="109.914" rx="8.573" ry="5.098" fill="#AFDAF7" />
    <defs>
      <filter
        id="b"
        x="54.724"
        y="36.386"
        width="12.901"
        height="10.229"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur" />
      </filter>
      <filter
        id="c"
        x="88.885"
        y="34.95"
        width="12.66"
        height="10.524"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur" />
      </filter>
      <filter
        id="d"
        x="0"
        y="48"
        width="152"
        height="95.538"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.77625 0 0 0 0 0.848793 0 0 0 0 0.9 0 0 0 1 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
      <clipPath id="a">
        <path fill="#fff" transform="translate(37)" d="M0 0h81v73H0z" />
      </clipPath>
    </defs>
  </svg>
);
